import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, IconButton, Button } from '@material-ui/core';
import _ from 'lodash';
import { CloseIcon } from '../Icon';
import { AutoCompleteSelect } from '../../components';

const useStyles = makeStyles((theme) => ({
  dialog: ({ maxWidth, dialogWidth }) => ({
    '& .MuiDialog-paperWidthSm': {
      maxWidth: maxWidth ?? 'none',
      width: dialogWidth ?? 'unset',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
    },
  }),
  dialogRoot: ({ width, p }) => ({
    padding: p ?? '2.375rem 1.563rem 1.875rem',
    width: width ?? '43.75rem',
    display: 'flex',
    overflowY: 'auto',
    flexDirection: 'column',
  }),
  dialogHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1.563rem',
  },
  dialogTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: '#2e4469',
    fontWeight: 'bold',
  },
  closeIconBtn: {
    borderRadius: '0rem',
    width: '1.5rem',
    height: '1.5rem',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
  },
  dialogContext: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
  dialogFoot: {
    marginTop: '3.25rem',
    display: 'flex',
    justifyContent: 'center',
  },
  dialogCancel: ({ isCapitalize }) => ({
    textTransform: isCapitalize ? 'capitalize' : 'none',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    backgroundColor: '#eff6ff',
    color: '#538fff',
    fontWeight: '500',
    borderRadius: '0.625rem',
    border: '0.12rem solid #538fff',
    minWidth: '12.5rem',
    height: '3rem',
    marginRight: '1.25rem',
    '&:hover': {
      backgroundColor: '#eff6ff',
    },
    '&:disabled': {
      backgroundColor: '#c0c6cb !important',
      color: '#ffffff !important',
    },
  }),
  dialogConfirm: ({ isCapitalize }) => ({
    textTransform: isCapitalize ? 'capitalize' : 'none',
    minWidth: '12.5rem',
    height: '3rem',
    borderRadius: '0.5rem',
    backgroundColor: '#4c93ff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: '#FFFFFF',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
    '&:disabled': {
      backgroundColor: '#c0c6cb !important',
      color: '#ffffff !important',
    },
  }),
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    color: '#2e4469',
  },
  dialogHoc: {
    position: 'absolute',
    bottom: '0px',
    right: '0px',
  },
}));

export default function DiaLog({
  children,
  open,
  handleClose,
  handleCancel,
  handleCancelTransfer,
  handleConfirm,
  title,
  cancel,
  cancelTransfer,
  confirm,
  dialogfootStyle,
  dialogRootStyle,
  dialogContentStyle,
  dialogheadStyle,
  cancelID = 'dialog-cancel',
  cancelTransferID = 'dialog-cancelTransfer',
  confirmID = 'dialog-confirm',
  closeID = 'dialog-close',
  confirmStyle,
  cancelTransferStyle,
  cancelStyle,
  disabled = false,
  cancelDisable = false,
  readOnly = false,
  haveHead = true,
  haveFoot = true,
  haveClose = true,
  width,
  maxWidth,
  dialogWidth,
  p,
  serviceSupportProps,
  footerButtonList = [],
  isCapitalize = true,
}) {
  const classes = useStyles({ width, p, maxWidth, dialogWidth, isCapitalize });
  return (
    <Dialog className={classes.dialog} open={open}>
      <div className={classes.dialogRoot} style={dialogRootStyle}>
        {haveHead && (
          <div className={classes.dialogHead} style={dialogheadStyle}>
            <div className={classes.dialogTitle}>{title}</div>
            {haveClose && (
              <IconButton id={closeID} className={classes.closeIconBtn} onClick={handleClose}>
                <CloseIcon className={classes.closeIcon} />
              </IconButton>
            )}
          </div>
        )}
        <div className={classes.content} style={dialogContentStyle}>
          {children}
        </div>
        {haveFoot && (
          <div className={classes.dialogFoot} style={dialogfootStyle}>
            {_.map(footerButtonList, (btnItem) => {
              return React.isValidElement(btnItem) ? btnItem : null;
            })}
            {cancel && (
              <Button
                id={cancelID}
                className={classes.dialogCancel}
                onClick={handleCancel}
                style={cancelStyle}
                disabled={cancelDisable}
              >
                {cancel}
              </Button>
            )}
            {cancelTransfer && (
              <Button
                id={cancelTransferID}
                className={classes.dialogCancel}
                onClick={handleCancelTransfer}
                style={cancelTransferStyle}
                disabled={cancelDisable}
              >
                {cancelTransfer}
              </Button>
            )}
            {!readOnly && (
              <Button
                id={confirmID}
                className={classes.dialogConfirm}
                onClick={handleConfirm}
                style={confirmStyle}
                disabled={disabled}
              >
                {confirm}
              </Button>
            )}
            {serviceSupportProps?.Visible && (
              <AutoCompleteSelect
                width="22.238rem"
                height="3rem"
                value=""
                getOptionDisabled={serviceSupportProps.getOptionDisabled}
                disabled={serviceSupportProps?.disabled}
                className={classes.dialogHoc}
                itemList={serviceSupportProps.itemList}
                onChange={serviceSupportProps.handerChange}
                placeholder={serviceSupportProps.holder}
              />
            )}
          </div>
        )}
      </div>
    </Dialog>
  );
}
